import { useEffect, useState } from 'react';
import { IApiGetConsentFormReportParam } from '../types/api';
import { IResponseDataBody } from 'services/response';
import reportApis from '../apis';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import moment from 'moment';
import { REPORT_PAGE_SIZE } from '../constants';
import { IResConsentFormItem } from '../types/consentForm';
import uuid from 'utils/uuid';

const initialParams: IApiGetConsentFormReportParam = {
  startDate: moment().format(DATE_FORMAT),
  endDate: moment().format(DATE_FORMAT),
  page: 1,
  size: REPORT_PAGE_SIZE,
};

const useGetConsentReport = () => {
  const [data, setData] = useState<IResConsentFormItem[]>([]);
  const [page, setPage] = useState(1);
  const [totalElements, setTotalElements] = useState(0);

  const mutate = async (params: IApiGetConsentFormReportParam) => {
    setPage(params.page || 1);
    try {
      const res: IResponseDataBody<{ content: IResConsentFormItem[]; totalElements: number }> =
        await reportApis.getConsentFormReport(params);
      if (res.data.data?.content) {
        const mappingUniqueIdList =
          res.data.data?.content?.map((item) => ({
            ...item,
            id: uuid(),
          })) || [];
        setData(mappingUniqueIdList);
        setTotalElements(res.data.data?.totalElements || 0);
      }
    } catch (error) {
      setData([]);
      setTotalElements(0);
    }
  };

  const pagination = {
    current: page,
    pageSize: REPORT_PAGE_SIZE,
    total: totalElements,
    showSizeChanger: false,
  };

  useEffect(() => {
    mutate(initialParams);
  }, []);

  return { data, mutate, pagination };
};

export default useGetConsentReport;
